/*eslint-disable*/
import React from 'react'
import { Modal } from 'semantic-ui-react'

const EditModal = (props) => {
    return (
        <>
            <Modal {...props}
                open={props.open}
                onClose={props.onClose}>
                {props.children}
            </Modal>
        </>
    )
}

export default EditModal
